import { Axios, AxiosService } from '@/services/Axios';
import { clearPhoneNumberFormatting } from '@/utils/format-phone-number';

import { CreateDesignToOrderVm } from '../../types';
import { dateType } from '../Activity';

export class OrderControllerClass {
  constructor(private APIService: AxiosService) {}

  fetchOrder = (orderId: string) => this.APIService.get(`/orders/${orderId}`);

  createDesignToOrder = (order: CreateDesignToOrderVm) => {
    const { shipmentContact } = order;

    const payload: CreateDesignToOrderVm = {
      ...order,
      shipmentContact: null,
    };

    if (shipmentContact) {
      payload.shipmentContact = {
        ...shipmentContact,
        eligibleEdit: false,
        phoneNumber: clearPhoneNumberFormatting(shipmentContact.phoneNumber),
      };
    }

    return this.APIService.post('/orders/create-design-to-order', payload);
  };

  updatePhotoAlbumLink = (id: string, photoAlbumLink: string) => {
    return this.APIService.patch(`/orders/${id}`, { photoAlbumLink });
  };

  fetchAllBucketFilesById = (bucketId: string) => {
    return this.APIService.get(`/buckets/${bucketId}/get-files`);
  };

  fetchOrderHistory = (opportunityId: string) => {
    return this.APIService.get(
      `orders?OpportunityId=${opportunityId}&ShouldContainOpsProject=false&MostCurrentOrder=false`,
    );
  };

  setTaskDate = (orderId: string, dateTaskType: dateType, date: string) => {
    return this.APIService.post('/orders/date-task', {
      orderId,
      dateTaskType,
      date,
    });
  };

  setRoofInstallComplete = (orderId: string, isComplete: boolean) => {
    return this.APIService.post(`/orders/${orderId}/roof-install`, isComplete);
  };

  fetchOrderMetrics = (dateOption: string) => {
    return this.APIService.get(`/metrics/orders?period=${dateOption}`);
  };
}

export const OrderController = new OrderControllerClass(Axios);
